import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";

const Success = () => {
   // Success page loading Time
   const [loading, setLoading] = useState(true);
   const navigate = useNavigate(); // Initialize the navigate hook

   useEffect(() => {
     if(loading){
      setTimeout(() => {
         setLoading(false);
      }, 2000);
     }else{
      setTimeout(() => {
         // setLoading(false);
         navigate("/")
      }, 2000);
     }

   }, [loading]);
   return (
      <div className="flex items-center justify-center h-screen">
         {loading ? (
            <PropagateLoader color="#ffb703" />
         ) : (
            <div className="text-center ">
               <h1 className="mb-2 text-xl font-semibold text-yellow">
                  Order Successful!
               </h1>
               <p className="text-sm lg:text-lg">
                  Your Order has been Successfully placed
               </p>
            </div>
         )}
      </div>
   );
};

export default Success;
